import { SUPPORT_URL } from './supportURL';

interface KeyMap {
  [key: string]: string;
}

export const LINK_PLACEHOLDER = '{link}';

export interface AdviceLinkDefinition {
  label: string;
  to: string;
}

export type AdviceLinkDefinitionSet = AdviceLinkDefinition | AdviceLinkDefinition[];

interface AdviceLinkMap {
  [key: string]: AdviceLinkDefinitionSet;
}

export const ADVICE_ICON_PATH: KeyMap = {
  ad1: '/images/advice/megaphone.svg',
  ad2: '/images/advice/megaphone.svg',
  ad3: '/images/advice/megaphone.svg',
  ad4: '/images/advice/megaphone.svg',
  ad5: '/images/advice/megaphone.svg',
  ad6: '/images/advice/megaphone.svg',
  ad7: '/images/advice/megaphone.svg',
  ad8: '/images/advice/megaphone.svg',
  ad9: '/images/advice/megaphone.svg',
  ad10: '/images/advice/megaphone.svg',
  ad11: '/images/advice/megaphone.svg',
  ad12: '/images/advice/megaphone.svg',
  ad13: '/images/advice/megaphone.svg',
  ad14: '/images/advice/megaphone.svg',
  default: '/images/advice/comment.svg',
};

// 実際にはad2, ad3のアドバイスは廃止されているので、本番で使われることはない
export const ADVICE_TEXT_JA: KeyMap = {
  ad1: `センサーが膀胱を捉えにくい状態かもしれません。「${LINK_PLACEHOLDER}」をお試しください。すでに設定されている場合は、${LINK_PLACEHOLDER}をご確認ください`,
  ad2: '測定が不安定なのは、姿勢の変化が影響しているかもしれません。「姿勢モード」をお試しください',
  ad3: '通知が多い場合は、設定から通知をオフにできます',
  ad4: `排尿後の数値が高い状態が続いています。装着位置の調整や、${LINK_PLACEHOLDER}をご確認ください`,
  ad5: `排尿回数が多くなっています。${LINK_PLACEHOLDER}をご確認ください`,
  ad6: `「そろそろ通知」が多いと感じる場合は、${LINK_PLACEHOLDER}をご確認のうえ「そろそろライン」の${LINK_PLACEHOLDER}や装着具合の見直しをお試しください。`,
  ad7: `「でたかも通知」が多いと感じる場合は、${LINK_PLACEHOLDER}をご確認のうえ「活動レベル設定」の${LINK_PLACEHOLDER}や装着具合の見直しをお試しください。`,
  ad8: `「起き上がり通知」が多いと感じる場合は、${LINK_PLACEHOLDER}をご確認のうえ「通知時間帯」の${LINK_PLACEHOLDER}をお試しください。`,
  ad9: '尿のたまり具合をとらえ始めています。引き続き様子を見ていきましょう！',
  ad10: '尿のたまり具合を綺麗にとらえております！引き続きこちらのままご利用ください',
  ad11: 'DFreeと中継器の通信途切れが過去12時間に3回以上確認されました。DFree装着者に対して半径15m以内の位置に中継器が設置されているかご確認ください',
  ad12: 'ジェルが不足しているか、DFreeが浮いているかもしれません。ジェルの量を増やすか、DFreeが肌に密着しているかご確認ください',
  ad13: 'センサの位置を上げてください。1cm程度を目安にDFreeの装着位置の変更をお試しください',
  ad14: 'センサの位置を下げてください。1cm程度を目安にDFreeの装着位置の変更をお試しください',
  default: 'アドバイスがあります',
};

export const ADVICE_TEXT_EN: KeyMap = {
  ad1: 'The sensor may be having difficulty detecting your bladder. Try the "Contingency Mode"',
  ad2: 'Unstable measurements may be due to changes in posture. Try using "Posture Mode"',
  ad3: 'If you receive too many notifications, you can turn them off in the settings.',
  ad4: 'The values after urination remain high. Please adjust the position of the device and check the detailed care instructions.',
  ad5: 'You are urinating more frequently. Please check here for care to regulate your urination intervals.',
  ad6: `If you receive too many "Almost" notifications, try adjusting the notification threshold. You can also turn off notifications from the ${LINK_PLACEHOLDER}.`,
  ad7: `If you feel that you are getting too many "Check" notifications, try adjusting in the "Advanced Settings". You can turn off these notifications from the ${LINK_PLACEHOLDER}.`,
  ad8: `If you feel that you receive too many "Getting up" notifications, try adjusting the notification time period. You can turn off these notifications from the ${LINK_PLACEHOLDER}.`,
  ad9: 'I have some advice',
  ad10: 'I have some advice',
  ad11: 'I have some advice',
  ad12: 'I have some advice',
  ad13: 'I have some advice',
  ad14: 'I have some advice',
  default: 'I have some advice',
};

export const ADVICE_LINK_JA: AdviceLinkMap = {
  ad1: [
    {
      label: '救済モード',
      to: '/nursinghome/:nursingHomeId/residents/:residentId/edit#advanced-settings',
    },
    {
      label: '装着のコツ',
      to: SUPPORT_URL.advice.ad1.ja,
    },
  ],
  ad4: {
    label: '詳しいケア方法',
    to: SUPPORT_URL.advice.ad4.ja,
  },
  ad5: {
    label: '排尿間隔を調整するケア',
    to: SUPPORT_URL.advice.ad5.ja,
  },
  ad6: [
    {
      label: 'こちら',
      to: 'https://dfree.biz/professional/support#solutions_notice_07',
    },
    {
      label: '調整',
      to: '/nursinghome/:nursingHomeId/residents/:residentId/edit#notification-settings',
    },
  ],
  ad7: [
    {
      label: 'こちら',
      to: 'https://dfree.biz/professional/support#solutions_notice_08',
    },
    {
      label: '調整',
      to: '/nursinghome/:nursingHomeId/residents/:residentId/edit#notification-settings',
    },
  ],
  ad8: [
    {
      label: 'こちら',
      to: 'https://dfree.biz/professional/support#solutions_notice_09',
    },
    {
      label: '調整',
      to: '/nursinghome/:nursingHomeId/residents/:residentId/edit#notification-settings',
    },
  ],
};

export const ADVICE_LINK_EN: AdviceLinkMap = {
  ad6: {
    label: 'settings',
    to: '/nursinghome/:nursingHomeId/residents/:residentId/edit#notification-settings',
  },
  ad7: {
    label: 'settings',
    to: '/nursinghome/:nursingHomeId/residents/:residentId/edit#notification-settings',
  },
  ad8: {
    label: 'settings',
    to: '/nursinghome/:nursingHomeId/residents/:residentId/edit#notification-settings',
  },
};
